import './App.css';

import View from "./View/View/View";

function App() {

return (
    <View>

    </View>
    );


}

export default App;
